module.exports = __webpack_public_path__ + "static/media/isShared.ac570b49.svg";